function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectArrowDownNew = function SvgSelectArrowDownNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 31"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m15 20.611 9.671-9.671-.883-.884L15 18.843l-8.787-8.787-.884.884z",
    clipRule: "evenodd",
    style: {
      fill: "currentColor"
    }
  }));
};
export { SvgSelectArrowDownNew as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzEiIGZpbGw9Im5vbmUiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHN0eWxlPgogICAgICAgIC5maWxsLWNvbG9yIHsKICAgICAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8cGF0aCBjbGFzcz0iZmlsbC1jb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4wMDAyIDIwLjYxMUwyNC42NzE0IDEwLjkzOTlMMjMuNzg3NSAxMC4wNTZMMTUuMDAwMiAxOC44NDMyTDYuMjEyOTkgMTAuMDU2TDUuMzI5MSAxMC45Mzk5TDE1LjAwMDIgMjAuNjExWiIgLz4KPC9zdmc+Cg==";